import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { advertisement, ServiceService } from 'src/app/service.service';
import { RoscasAmericanasEstandarizadasToleranciasPaso } from 'src/app/constants/tablas-utiles';

@Component({
  selector: 'app-rosc-amer-estd-toler-p',
  templateUrl: './rosc-amer-estd-toler-p.page.html',
  styleUrls: ['./rosc-amer-estd-toler-p.page.scss'],
})
export class RoscAmerEstdTolerPPage implements OnInit {
  public roscAmericanaForm:FormGroup = null;
  public americanThreads:Array<any> = [];
  public classThreads:Array<any> = null;
  public response:string = '';
  previousResult:string = null;
  isMovil:boolean = false;
  advertisements:advertisement = new advertisement();

  constructor(public services:ServiceService, private formBuilder:FormBuilder) {
    this.americanThreads = [...RoscasAmericanasEstandarizadasToleranciasPaso];
  }

  async ngOnInit() {
    this.roscAmericanaForm = this.formBuilder.group({
      nominalSize: ['', Validators.required ],
      typeThread: ['', Validators.required ],
      classThread: ['', Validators.required ],
    });
    this.isMovil = this.services.isMovil();
    if(!this.isMovil){
      this.advertisements = await this.services.getAdvertisementByScreen(8,1);
      this.advertisements.Displayed = this.advertisements.MediaBasico.slice(0,this.advertisements.Rows);
      this.advertisements.Random = this.services.NumberRandom(this.advertisements.Principal.length);
      this.services.postAdvertisementUser(this.advertisements.getAllRelAdsMetricsIdDisplayed());
    }
  }

  onChangeNominalSize(ev:any){
    this.roscAmericanaForm.controls.typeThread.setValue(undefined);
    this.roscAmericanaForm.controls.classThread.setValue(undefined);
  }

  onChangeTypeThread(ev:any){
    let type = ev.target.value;
    let selectedThread = this.americanThreads[this.roscAmericanaForm.controls.nominalSize.value];
    this.classThreads = [];
    if(type==1){
      this.classThreads = selectedThread.roscaExterna;
    }else if(type==2){
      this.classThreads = selectedThread.roscaInterna;
    }

    // this.response = '';
    this.roscAmericanaForm.controls.classThread.setValue(undefined);
  }

  reset(){
    this.roscAmericanaForm.reset();
  }
  isSharing:boolean = false;
  calcular(){
    if(!this.roscAmericanaForm.valid)
      return;

    let selected = this.classThreads[this.roscAmericanaForm.controls.classThread.value];
    let type = this.roscAmericanaForm.controls.typeThread.value;
    if(type==1){
      this.response = selected ? 
      `<br>Diámetro mayor / Limites:<br>
      Máximo: ${selected.diametroMayorLimites.maximo}"<br>
      Mínimo: ${selected.diametroMayorLimites.minimo}"<br><br>
      Paso / Límites:<br>
      Máximo: ${selected.pasoLimites.maximo}"<br>
      Mínimo: ${selected.pasoLimites.minimo}"<br>
      Tolerancia: ${selected.pasoLimites.tolerancia}"<br><br>
      Diámetro de fondo:<br>
      ${selected.diametroDeFondo}" <br><br>
      Ajuste: <br>
      ${selected.ajuste ? selected.ajuste : ''}`
      : '';
    }else if(type==2){
      this.response = selected ? 
      `<br>
      Diámetro menor:<br>
      Máximo: ${selected.diametroMenor.maximo}"<br>
      Mínimo: ${selected.diametroMenor.minimo}"<br><br>
      Paso / Limites:<br>
      Máximo: ${selected.pasoLimites.maximo}"<br>
      Mínimo: ${selected.pasoLimites.minimo}"<br>
      Tolerancia: ${selected.pasoLimites.tolerancia}"<br><br>
      Diámetro exterior:<br>
      ${selected.diametroExterior}" <br><br>
      Ajuste: <br>
      ${selected.ajuste ? selected.ajuste : '' }`
      : '';
    }
    // despues de procesar respuesta
    if(this.previousResult != this.response && !this.isSharing){
      this.previousResult = this.response;
      this.isSharing = true;
      setTimeout(()=>{ this.isSharing = false; },20000);
      this.services.addPointCalculator();
    }
  }
}
